// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  inf = 190,
  nan = 191,
  Bool = 1,
  Ignoring = 2,
  On = 3,
  GroupLeft = 4,
  GroupRight = 5,
  Offset = 6,
  Outer = 7,
  Atan2 = 8,
  Avg = 9,
  Bottomk = 10,
  Count = 11,
  CountValues = 12,
  CardinalityEstimate = 13,
  Group = 14,
  Max = 15,
  Min = 16,
  Quantile = 17,
  Stddev = 18,
  Stdvar = 19,
  Sum = 20,
  Topk = 21,
  Zscore = 22,
  By = 23,
  Without = 24,
  And = 25,
  Or = 26,
  Unless = 27,
  Start = 28,
  End = 29,
  Fill = 30,
  FillLeft = 31,
  FillRight = 32,
  LineComment = 33,
  PromQL = 34,
  AggregateExpr = 35,
  AggregateOp = 36,
  TemplateVariable = 37,
  AggregateModifier = 38,
  GroupingLabels = 39,
  LabelName = 40,
  QuotedLabelName = 41,
  FunctionCallBody = 42,
  BinaryExpr = 43,
  Pow = 44,
  BoolModifier = 45,
  OuterModifier = 46,
  MatchingModifierClause = 47,
  FillModifier = 48,
  FillClause = 49,
  NumberLiteral = 50,
  FillLeftClause = 51,
  FillRightClause = 52,
  Mul = 53,
  Div = 54,
  Mod = 55,
  Add = 56,
  Sub = 57,
  Eql = 58,
  Gte = 59,
  Gtr = 60,
  Lte = 61,
  Lss = 62,
  Neq = 63,
  FunctionCall = 64,
  FunctionIdentifier = 65,
  AbsentOverTime = 66,
  Identifier = 67,
  Absent = 68,
  Abs = 69,
  Acos = 70,
  Acosh = 71,
  Asin = 72,
  Asinh = 73,
  Atan = 74,
  Atanh = 75,
  AvgOverTime = 76,
  Ceil = 77,
  Changes = 78,
  Clamp = 79,
  ClampMax = 80,
  ClampMin = 81,
  Cos = 82,
  Cosh = 83,
  CountOverTime = 84,
  DaysInMonth = 85,
  DayOfMonth = 86,
  DayOfWeek = 87,
  DayOfYear = 88,
  Deg = 89,
  Delta = 90,
  Deriv = 91,
  Exp = 92,
  Floor = 93,
  HistogramCount = 94,
  HistogramFraction = 95,
  HistogramQuantile = 96,
  HistogramStdDev = 97,
  HistogramStdVar = 98,
  HistogramSum = 99,
  HistogramAvg = 100,
  HoltWinters = 101,
  DoubleExponentialSmoothing = 102,
  Hour = 103,
  Idelta = 104,
  Increase = 105,
  Irate = 106,
  LabelReplace = 107,
  LabelJoin = 108,
  LastOverTime = 109,
  Ln = 110,
  Log10 = 111,
  Log2 = 112,
  MaxOverTime = 113,
  MinOverTime = 114,
  Minute = 115,
  Month = 116,
  Pi = 117,
  PredictLinear = 118,
  PresentOverTime = 119,
  QuantileOverTime = 120,
  Rad = 121,
  Rate = 122,
  Resets = 123,
  Round = 124,
  Scalar = 125,
  Sgn = 126,
  Sin = 127,
  Sinh = 128,
  Sort = 129,
  SortDesc = 130,
  Sqrt = 131,
  StddevOverTime = 132,
  StdvarOverTime = 133,
  SumOverTime = 134,
  Tan = 135,
  Tanh = 136,
  Timestamp = 137,
  Time = 138,
  Vector = 139,
  Year = 140,
  AnomalyBounds = 141,
  AnomalyMonitor = 142,
  Cumsum = 143,
  DefaultOverTime = 144,
  Ewma = 145,
  HistogramObservations = 146,
  HistogramQuantiles = 147,
  HistogramQuantilesLegacy = 148,
  PiecewiseConstant = 149,
  RobustTrend = 150,
  SortHeadAvg = 151,
  SortHeadMin = 152,
  SortHeadMax = 153,
  SortHeadSum = 154,
  SortHeadCount = 155,
  SortTailAvg = 156,
  SortTailMin = 157,
  SortTailMax = 158,
  SortTailSum = 159,
  SortTailCount = 160,
  SumPerSecond = 161,
  TrendLine = 162,
  TsOfFirstOverTime = 163,
  TsOfLastOverTime = 164,
  TsOfMinOverTime = 165,
  TsOfMaxOverTime = 166,
  MatrixSelector = 167,
  Duration = 168,
  OffsetExpr = 169,
  ParenExpr = 170,
  StringLiteral = 171,
  SubqueryExpr = 172,
  UnaryExpr = 173,
  UnaryOp = 174,
  VectorSelector = 175,
  LabelMatchers = 176,
  LabelMatcher = 177,
  MatchOp = 178,
  EqlSingle = 179,
  EqlRegex = 180,
  NeqRegex = 181,
  StepInvariantExpr = 182,
  At = 183,
  AtModifierPreprocessors = 184,
  MetricName = 185
